import React from 'react';

export interface TabItem<T extends string = string> {
  id: T;
  label: string;
  icon?: React.ReactNode;
  badge?: string | number;
}

export interface SegmentedTabsProps<T extends string = string> {
  tabs: TabItem<T>[];
  activeTab: T;
  onChange: (tabId: T) => void;
  rightControls?: React.ReactNode;
  className?: string;
  listClassName?: string;
  buttonClassName?: string;
  badgeClassName?: string;
  style?: React.CSSProperties;
}

export function SegmentedTabs<T extends string = string>({
  tabs,
  activeTab,
  onChange,
  rightControls,
  className = '',
  listClassName = '',
  buttonClassName = '',
  badgeClassName = '',
  style,
}: SegmentedTabsProps<T>): React.ReactElement {
  return (
    <div className={`ns-inst-tabs ${className}`} style={style}>
      <div className={`ns-inst-tabs__list ${listClassName}`}>
        {tabs.map((tab) => {
          const isActive = tab.id === activeTab;
          return (
            <button
              key={tab.id}
              type="button"
              aria-pressed={isActive}
              className={`ns-inst-tab-btn ${buttonClassName} ${isActive ? 'is-active active' : ''}`}
              onClick={() => onChange(tab.id)}
            >
              {tab.icon}
              <span>{tab.label}</span>
              {tab.badge !== undefined && tab.badge !== null && (
                <span className={`ns-inst-tab-badge ${badgeClassName}`}>{tab.badge}</span>
              )}
            </button>
          );
        })}
      </div>

      {rightControls && <div className="ns-inst-tabs__right">{rightControls}</div>}
    </div>
  );
}

export default SegmentedTabs;
